import { useWelcomeModal } from '@ibk/shared-ui';
import { ContractStatus } from '../types';
import { useHasRecharges } from './useHasRecharges';
export function useWelcomeModalWithRecharges(options = {}) {
    const { contract, enabled = true } = options;
    const hasActiveContract = contract?.status === ContractStatus.ACTIVE;
    const { hasRecharges: hasRechargesFromApi, isLoading: isRechargesLoading, error: rechargesError, checkHasRecharges, } = useHasRecharges({
        contractId: contract?.id,
        enabled: enabled && hasActiveContract,
    });
    const welcomeModalState = useWelcomeModal({
        voucherContractId: contract?.id,
        hasActiveContract,
        checkHasRecharges,
        enabled,
    });
    return {
        ...welcomeModalState,
        hasRechargesFromApi,
        isRechargesLoading,
        rechargesError,
    };
}
